<template>
    <v-dialog v-model="showDialog" :max-width="showAllMRForEquipment ? null : 1200">
        <v-card>
            <v-card-title class="primary white--text title">
                {{ currentItem.title }}
            </v-card-title>
            <v-card-text>
                <p class="headline">
                    {{ 'Equipment'|translate }} : {{ currentItem.equip }}
                </p>
                <p>
                    {{ currentItem.description }}
                </p>
                <p>
                    {{ 'Occured between'|translate }} <strong> {{ currentItem.startDate.replace('T', ' ') }}</strong>
                    {{ 'and'|translate }}
                    <strong>{{ currentItem.endDate.replace('T', ' ') }}</strong>
                </p>
            </v-card-text>
            <v-divider v-if="currentItem.recommendedActions"></v-divider>
            <v-card-text v-if="currentItem.recommendedActions">
                <p class="headline">
                    {{ 'Recommended Actions'|translate }}
                </p>
                <ul v-if="currentItem.recommendedActions">
                    <li v-for="(i, idx) in currentItem.recommendedActions.split('\n')" :key="idx">
                        {{ i }}
                    </li>
                </ul>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap>
                    <p class="headline">
                        {{ 'Maintenance Records'|translate }}
                    </p>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-switch color="success" v-model="showAllMRForEquipment" class="pa-0 ma-0 pt-3 pl-2"
                                                         :label="'Show All Maintenance Records'|translate"></v-switch> </span>

                </v-layout>
                <v-data-table
                    v-if="currentItem.maintenance_records&&currentItem.maintenance_records.length>0"
                    :headers="maintenanceHeaders"
                    :items="currentItem.maintenance_records"
                    class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                            {{ props.item.maintenance_id }}
                        </td>
                        <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                            {{ props.item.maintenance_label }}
                        </td>
                        <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                            <v-icon v-if="props.item.is_fixed" color="success">fa-check</v-icon>
                            <v-icon v-else color="warning">fa-times</v-icon>
                        </td>

                        <td @click="editMR(props.item)" class="cursor-as-pointer text-xs-left">
                            {{ props.item.assigned_to }}
                        </td>
                        <td class="cursor-as-pointer text-xs-left">{{ props.item.assigned_by }}</td>
                        <td class="cursor-as-pointer text-xs-left">
                            <span v-if="props.item.assigned_date&&props.item.assigned_date!=='NaT'">{{
                                    props.item.assigned_date.substring(0, 10)
                                }}</span>
                        </td>
                        <td  class="cursor-as-pointer text-xs-left">
                            <v-icon small @click="editMR(props.item)">fa-edit</v-icon>
                        </td>

                    </template>
                    <template v-slot:no-data>
                        <v-btn color="primary" @click="$emit('refresh')">{{ 'Refresh'|translate }}</v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-text v-if="showAllMRForEquipment">
                <p class="headline">
                    {{ 'All Maintenance Records for '|translate }} {{ currentItem.equip }}
                </p>
                <maintenance-record :equipment-filter="currentItem.equip" ></maintenance-record>
            </v-card-text>
            <v-divider v-if="currentItem.ack_by || currentItem.muted_by"></v-divider>
            <v-card-text v-if="currentItem.ack_by || currentItem.muted_by">
                <v-layout row wrap>
                    <v-flex xs12 md6 v-if="currentItem.ack_by">
                        <p class="subheading">
                            <strong>{{ 'Acknowledged by'|translate }}:</strong> {{ currentItem.ack_by }}
                        </p>
                        <p v-if="currentItem.last_ack_date" class="body-1">
                            <strong>{{ 'Last acknowledged date'|translate }}:</strong> {{ currentItem.last_ack_date && currentItem.last_ack_date.replace ? currentItem.last_ack_date.replace('T', ' ') : currentItem.last_ack_date }}
                        </p>
                    </v-flex>
                    <v-flex xs12 md6 v-if="currentItem.muted_by">
                        <p class="subheading">
                            <strong>{{ 'Muted by'|translate }}:</strong> {{ currentItem.muted_by }}
                        </p>
                        <p v-if="currentItem.muted_date" class="body-1">
                            <strong>{{ 'Muted date'|translate }}:</strong> {{ currentItem.muted_date && currentItem.muted_date.replace ? currentItem.muted_date.replace('T', ' ') : currentItem.muted_date }}
                        </p>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap justify-center>
                    <v-btn class="ma-2" @click="onLikeNotification" color="primary">
                        <v-icon class="mr-2">fa-thumbs-up</v-icon>
                        {{ 'Mark as Useful'|translate }}
                    </v-btn>
                    
                    <v-btn class="ma-2" @click="onMuteNotification" color="primary">
                        <v-icon class="mr-2" v-if="!currentItem.muted">fa-volume-up</v-icon>
                        <v-icon class="mr-2" v-else>fa-volume-mute</v-icon>
                        {{ (currentItem.muted ? 'Un-Mute' : 'Mute')|translate }}
                    </v-btn>
                    
                    <v-btn class="ma-2" @click="onModifyRules" color="primary" v-if="$can('update', 'Rule')">
                        <v-icon class="mr-2">fa-cog</v-icon>
                        {{ 'Modify Logic and Severity'|translate }}
                    </v-btn>
                    
                    <v-btn class="ma-2" @click="onCallMaintenanceDialog" color="primary">
                        <v-icon class="mr-2">fa-wrench</v-icon>
                        {{ 'Create maintenance record'|translate }}
                    </v-btn>
                    
                    <v-btn class="ma-2" @click="onToggleAcknowledge" color="primary">
                        <v-icon class="mr-2" v-if="!currentItem.acknowledged">fa-bell</v-icon>
                        <v-icon class="mr-2" v-else>fa-bell-slash</v-icon>
                        {{ (currentItem.acknowledged ? 'Un-Acknowledge' : 'Acknowledge')|translate }}
                    </v-btn>
                </v-layout>
            </v-card-text>
            <v-card-actions>

                <v-btn class="primary ml-2 elevation-4" @click="onJumpToLink">
                    <v-icon class="mr-2">fa-chart-line</v-icon>
                    {{ 'View Chart'|translate }}
                </v-btn>
                <v-btn class="primary elevation-4" @click="onJumpToLinkNW">
                    <v-icon class="mr-2">fa-chart-line</v-icon>
                    {{ 'View Chart in New Tab'|translate }}
                </v-btn>
                <v-btn icon v-if="!currentItem.acknowledged"
                       @click="onTrigger(false)">
                    <v-icon color="warning">fa-bell</v-icon>
                </v-btn>
                <v-btn icon v-if="currentItem.acknowledged"
                       @click="onTrigger(true)">
                    <v-icon color="grey">fa-bell-slash</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn outline class="mr-2" @click="showDialog = false">
                    {{ 'Close'|translate }}
                </v-btn>
            </v-card-actions>
            <fault-record-dialog v-model="maintenanceDialog" :item="maintenanceItem"
                                 v-on:doreload="$emit('refresh')"></fault-record-dialog>
        </v-card>
    </v-dialog>
</template>

<script>
import FaultRecordDialog from './FaultRecordDialog'
import MaintenanceRecord from '../views/MaintenanceRecord.vue'

export default {
    name: 'NotificationDetailDialog',
    components: {FaultRecordDialog, MaintenanceRecord},
    props: {
        value: {type: Boolean, default: false},
        item: {type: Object, default: () => ({
            title: '',
            equip: '',
            description: '',
            startDate: '',
            endDate: '',
            recommendedActions: '',
            maintenance_records: [],
            acknowledged: false,
            notification_id: null,
            ack_by: null,
            last_ack_date: null,
            muted_by: null,
            muted_date: null,
            muted: false
        })},
        maintenanceHeaders: {
            type: Array,
            default() {
                return [
                    {
                        text: this.$options.filters.translate('ID'),
                        align: 'left',
                        sortable: true,
                        value: 'maintenance_id'
                    },
                    {
                        text: this.$options.filters.translate('Fault'),
                        align: 'left',
                        sortable: true,
                        value: 'maintenance_label'
                    },
                    {text: this.$options.filters.translate('Fixed'), value: 'is_fixed'},
                    {text: this.$options.filters.translate('Assigned to'), value: 'assigned_to'},
                    {text: this.$options.filters.translate('Assigned by'), value: 'assigned_by'},
                    {text: this.$options.filters.translate('Assigned date'), value: 'assigned_date'},
                    {text: this.$options.filters.translate('Actions'), sortable: false},
                ]
            }
        }
    },
    data() {
        return {
            showAllMRForEquipment: false,
            maintenanceDialog: false,
            maintenanceItem: null,
        }
    },
    computed: {
        showDialog: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        currentItem() {
            return this.item
        }
    },
    methods: {
        editMR(item) {
            this.maintenanceItem = JSON.parse(JSON.stringify(item))
            this.maintenanceDialog = true
        },
        getItemUrl(item) {
            let output = null;
            if (item.title.substring(0, 7) === "Anomaly") {
                output = {
                    path: '/modelsummary',
                    query: {
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipment: item.equip
                    }
                }
            } else if (item.topic === "equipment health") {
                output = {
                    path: '/equipment-health',
                    query: {
                        equipment: item.equip,
                    }
                }
            } else {
                output = {
                    path: '/fault-analysis',
                    query: {
                        relevantVariables: item.to.query.variableX,
                        faultName: item.title,
                        faultDesc: item.description,
                        rangeStart: item.to.query.rangeStart,
                        rangeEnd: item.to.query.rangeEnd,
                        equipmentName: item.equip,
                        nId: item.notification_id,
                        nTopic: item.topic,
                        nOct: item.occurredTimes
                    }
                }
            }
            return output
        },
        getMaintenanceItem(item) {
            let itemUrlObj = this.getItemUrl(item)
            return {
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                equipment: item['equip'],
                maintenance_date_from: item['startDate'],
                maintenance_date_to: item['endDate'],
                severity: item['severity'],
                maintenance_text: this.$options.filters.translate('Recommended Actions:') + ' \n\n' + item['recommendedActions'],
                maintenance_label: item['title'],
                url: this.$router.resolve(itemUrlObj).href,
                notification_id: item['notification_id'],
                is_fixed: false,
                maintenance_id: null
            }
        },
        onCallMaintenanceDialog() {
            this.maintenanceItem = this.getMaintenanceItem(this.currentItem)
            this.maintenanceDialog = true
        },
        onJumpToLink() {
            this.$emit('jump-to-link', this.currentItem)
        },
        onJumpToLinkNW() {
            this.$emit('jump-to-link-nw', this.currentItem)
        },
        onTrigger(currentState) {
            this.$emit('trigger', this.currentItem.notification_id, currentState)
        },
        onLikeNotification() {
            // Call snackbar to show feedback
            this.$store.dispatch('callSnackbar', {
                text: this.$options.filters.translate('Thank you for your feedback!')
            })
            // Log event with notification_id
            this.$store.dispatch('logEvent', {
                type: 'liked_notification',
                data: {
                    notification_id: this.currentItem.notification_id
                }
            })
        },
        onMuteNotification() {
            // Toggle mute status
            const newMuteState = !this.currentItem.muted
            this.$emit('mute', this.currentItem.notification_id, newMuteState)
            // Note: Parent component should update the item's muted state
        },
        onModifyRules() {
            // Navigate to rules page
            // If topic is available, could filter by it, but for now just navigate to rules
            this.$router.push({
                path: '/rules'
            })
        },
        onToggleAcknowledge() {
            // Toggle the acknowledgment state
            this.onTrigger(this.currentItem.acknowledged)
        }
    }
}
</script>
